<template>
  <div>
    <b-row>
      <b-col cols="12" class="text-left">
        <b-card>
          <b-row class="mb-4">
            <b-col cols="6">
              <div>
                <p>Copy Stop Words</p>
                <b-input-group class="mt-3">
                  <template v-slot:prepend>
                    <b-button
                      :disabled="searchPage"
                      variant="outline-warning"
                      @click="copyAllStopWords"
                      style="height:35px;"
                    >Add All</b-button>
                  </template>
                  <v-select
                    size="sm"
                    :searchable="true"
                    :clearable="true"
                    :multiple="true"
                    label="text"
                    :disabled="searchPage"
                    v-model="selectStopWords"
                    :options="stopWordsList"
                    style="width: 72%;"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        @focus="copyStopWords()"
                      />
                    </template>
                  </v-select>
                  <b-input-group-append>
                    <b-button
                      variant="outline-warning"
                      @click="pasteStopWords"
                      :disabled="searchPage"
                      style="height:35px;"
                    >Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="mt-3">
                <p>Add Stop Words From Other Pri's</p>
                <b-input-group class="mt-3">
                  <template v-slot:prepend>
                    <b-button
                      variant="outline-warning"
                      :disabled="searchPage"
                      @click="copyAllStopWordsFromOtherPri"
                      style="height:35px;"
                    >Add All</b-button>
                  </template>
                  <v-select
                    size="sm"
                    :searchable="true"
                    :clearable="true"
                    :multiple="true"
                    :disabled="searchPage"
                    label="text"
                    v-model="selectStopWordsFromOtherPri"
                    :options="uniqPriConfigrationStopWordsData"
                    style="width: 72%;"
                  ></v-select>
                  <b-input-group-append>
                    <b-button
                      variant="outline-warning"
                      :disabled="searchPage"
                      @click="pasteStopWordsFromOtherPri"
                      style="height:35px;"
                    >Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
            <b-col cols="6">
              <b-form-checkbox
                :disabled="searchPage"
                @change="disableRemovalTextValue"
                v-model="disableRemovalText"
              >Disable the removal of text in (Text)</b-form-checkbox>
            </b-col>
          </b-row>
          <h4>Stop Keywords</h4>
          <b-input-group class="mt-3">
            <b-form-input
              :disabled="searchPage"
              placeholder="Enter the phrases you would like to be removed from the search string..."
              @keyup.enter="addStopWords()"
              v-model="addStopWord"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="searchPage" @click="addStopWords" variant="outline-warning">Add</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-table
            :items="futureRiskTab ? $store.state.priConfigrationforms.futureRisks.categories[categoriesIndex].stopWords : $store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].stopWords"
            :fields="fieldsKeywords"
          >
            <template v-slot:cell(text)="data">
              <p>{{data.item}}</p>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                :disabled="searchPage"
                @click="removeStopWords(data)"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "StopwordsComponent",
  data() {
    return {
      disableRemovalText: false,
      stopWordsList: [],
      selectStopWords: [],
      addStopWord: null,
      selectStopWordsFromOtherPri: [],
      fieldsKeywords: [
        { key: "text", label: "Keyword" },
        { key: "Actions", label: "Actions" }
      ],
      uniqPriConfigrationStopWordsData: []
    };
  },
  mounted() {
    this.uniqPriConfigrationStopWordsData = _.uniq(
      this.priConfigrationStopWordsData
    );
    if (this.negativeMediaEdit) {
      this.disableRemovalText = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].disableRemovalText;
    }
    if (this.futureRisksEdit) {
      this.disableRemovalText = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].disableRemovalText;
    }
  },
  methods: {
    disableRemovalTextValue(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].disableRemovalText = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].disableRemovalText = value;
      }
    },
    copyStopWords() {
      this.stopWordsList = [];
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
    },
    copyAllStopWords() {
      let stopWordsData = [];
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      } else {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      }

      stopWordsData.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].stopWords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].stopWords.unshift(value);
        }
      });
    },
    pasteStopWords() {
      this.selectStopWords.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].stopWords.unshift(value.text);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].stopWords.unshift(value.text);
        }
      });
      this.stopWordsList = [];
      this.selectStopWords = [];
    },
    addStopWords() {
      if (this.addStopWord) {
        let stopWordsData = this.futureRiskTab
          ? this.$store.state.priConfigrationforms.futureRisks.categories[
              this.categoriesIndex
            ].stopWords
          : this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].stopWords;
        stopWordsData.unshift(this.addStopWord);
      }
      this.addStopWord = null;
    },
    removeStopWords(data) {
      let stopWordsData = this.futureRiskTab
        ? this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].stopWords
        : this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].stopWords;
      let stopWordsIndex = stopWordsData.indexOf(data.item);
      stopWordsData.splice(stopWordsIndex, 1);
    },

    pasteStopWordsFromOtherPri() {
      this.selectStopWordsFromOtherPri.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].stopWords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].stopWords.unshift(value);
        }
      });
      this.selectStopWordsFromOtherPri = [];
    },

    copyAllStopWordsFromOtherPri() {
      this.uniqPriConfigrationStopWordsData.map(data => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].stopWords.unshift(data);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].stopWords.unshift(data);
        }
      });
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean,
    priConfigrationStopWordsData: Array
  }
};
</script>